const initialState = {
    latlong: ''
  };
  
  const latlongReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_LAT_LONG':
            return { ...state, latlong: action.payload };
        default:
            return state;
    }
  };
  
  export default latlongReducer;
  